import $ from 'jquery';
import 'slick-carousel';

const sliderTeam = () => {
	if (window.innerWidth <= 1024) {
		$('.loop-slider_team .elementor-loop-container')
			.not('.slick-initialized')
			.slick({
				slidesToShow: 2,
				slidesToScroll: 2,
				infinite: true,
				centerMode: false,
				arrows: false,
				responsive: [
					{
						breakpoint: 1025,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							variableWidth: false,
							arrows: false,
							infinite: true,
						},
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							variableWidth: false,
							arrows: false,
							infinite: true,
						},
					},
					{
						breakpoint: 601,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							variableWidth: false,
							arrows: false,
							infinite: true,
						},
					},
					{
						breakpoint: 576,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							variableWidth: false,
							arrows: false,
							infinite: true,
						},
					},
				],
			});
	} else {
		if (
			$('.loop-slider_team .elementor-loop-container ').hasClass(
				'slick-initialized',
			)
		) {
			$('.loop-slider_team .elementor-loop-container ').slick('unslick');
		}
	}
};

$(window).on('resize', function () {
	sliderTeam();
});

$(document).ready(function () {
	sliderTeam();
});
